// extracted by mini-css-extract-plugin
export default {"OrdersFormModal":"OrdersFormModal_OrdersFormModal__G0S7Q"};